import React from 'react';

import ContentSection from './components/Content';
import HeaderSection from './components/Header';
import { ModalProvider as ManagePackagesModalProvider } from './components/ManagePackagesModal';
import { SearchFiltersProvider } from './SearchFiltersContext';

const PackageUtilization = (): JSX.Element => {
  return (
    <SearchFiltersProvider>
      <ManagePackagesModalProvider>
        <HeaderSection />
        <ContentSection />
      </ManagePackagesModalProvider>
    </SearchFiltersProvider>
  );
};

export default PackageUtilization;
